import styled from 'styled-components'
import { background } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Column, Flex, Row } from 'Components/UI'

import { BORDER_RADIUS } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  px: [32, 32, 64, 97],
  pt: [32, 97],
})`
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  color: ${themeGet('colors.white')};
  border-top-right-radius: ${BORDER_RADIUS}px;
  border-bottom-left-radius: ${BORDER_RADIUS}px;

  ${background};
`

export const Content = styled(Column)`
  width: 100%;
  max-width: 1065px;
  align-items: center;
  justify-content: center;
`

export const ImageHolder = styled(Row)`
  padding-top: 55%;
  width: 100%;
  overflow: hidden;
  position: relative;

  div:first-child {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`
